import { ToastContainer } from '../../components/Common';
import DocumotoPartsSearchPage from './page';

const DocumotoPartsSearchPageWrapper = () => (
	<>
		<div className="page-content">
			<DocumotoPartsSearchPage />
		</div>
		<ToastContainer />
	</>
);

export default DocumotoPartsSearchPageWrapper;
